import * as React from 'react';

export const PostHandlingIcon: React.FunctionComponent = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 8.177L3.506 4.5H12.494L8 8.177ZM2.127 3.5C2.09332 3.5 2.06101 3.51338 2.0372 3.5372C2.01338 3.56101 2 3.59332 2 3.627V12.3735C2 12.4435 2.057 12.5 2.127 12.5H2.873C2.943 12.5 3 12.4435 3 12.3735V4.732L7.921 8.7585C7.94319 8.77696 7.97114 8.78707 8 8.78707C8.02886 8.78707 8.05682 8.77696 8.079 8.7585L13 4.732V11.3735C13 11.4435 12.9435 11.5 12.873 11.5H4.498C4.47479 11.5001 4.45204 11.5065 4.43228 11.5187C4.41252 11.5309 4.3965 11.5483 4.386 11.569L4.011 12.319C4.00144 12.3381 3.99692 12.3593 3.99788 12.3806C3.99883 12.4019 4.00523 12.4226 4.01646 12.4408C4.02769 12.4589 4.04337 12.4739 4.06202 12.4843C4.08067 12.4946 4.10166 12.5 4.123 12.5H13.873C13.8897 12.5001 13.9062 12.4968 13.9216 12.4905C13.937 12.4842 13.951 12.4749 13.9628 12.4631C13.9746 12.4514 13.9839 12.4374 13.9903 12.422C13.9967 12.4066 14 12.3902 14 12.3735V3.627C14 3.59332 13.9866 3.56101 13.9628 3.5372C13.939 3.51338 13.9067 3.5 13.873 3.5H2.127Z"
        fill="#3A3A3A"
      />
    </svg>
  );
};
